export const config = {
    //domain: 'http://localhost:3000/'
    domain: 'https://www.com1dav1rtual.com/'
    //domain: 'https://www.com1dav1rtual.com:2083/'
    //domain: "/" //intur
};  